/* Plakton motion layer. Scroll reveals, line splitting, media drift.
   Everything here is progressive: with JS off or reduced motion on,
   content is visible and static. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  if (reduced) {
    qsa('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  /* ---- split headlines into revealing lines -------------------------- */
  function splitLines(el) {
    if (el.dataset.split === 'done') return;
    var text = el.textContent.trim();
    if (!text) return;
    // Wrap each word, measure line boxes, then regroup by line top.
    var words = text.split(/\s+/);
    el.textContent = '';
    var probes = words.map(function (w, i) {
      var s = document.createElement('span');
      s.textContent = w + (i < words.length - 1 ? ' ' : '');
      s.style.display = 'inline-block';
      el.appendChild(s);
      return s;
    });
    var lines = [];
    var currentTop = null;
    probes.forEach(function (s) {
      var top = s.offsetTop;
      if (currentTop === null || Math.abs(top - currentTop) > 2) {
        lines.push([]);
        currentTop = top;
      }
      lines[lines.length - 1].push(s.textContent);
    });
    el.textContent = '';
    lines.forEach(function (words, i) {
      var outer = document.createElement('span');
      outer.className = 'split-line';
      var inner = document.createElement('span');
      inner.textContent = words.join('');
      inner.style.setProperty('--line-delay', (i * 90) + 'ms');
      outer.appendChild(inner);
      el.appendChild(outer);
    });
    el.dataset.split = 'done';
  }

  qsa('[data-split-lines]').forEach(function (el) {
    // fonts must be loaded or the measurement is wrong
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { splitLines(el); });
    } else {
      splitLines(el);
    }
  });

  /* ---- reveal on scroll ---------------------------------------------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function observe(root) {
    qsa('[data-reveal]', root).forEach(function (el, i) {
      if (el.dataset.revealStagger !== undefined) {
        el.style.setProperty('--reveal-delay', (i % 8) * 70 + 'ms');
      }
      io.observe(el);
    });
    // stagger children of a group
    qsa('[data-reveal-group]', root).forEach(function (group) {
      Array.prototype.slice.call(group.children).forEach(function (child, i) {
        child.setAttribute('data-reveal', group.getAttribute('data-reveal-group') || '');
        child.style.setProperty('--reveal-delay', i * 80 + 'ms');
        io.observe(child);
      });
      group.removeAttribute('data-reveal-group');
    });
  }
  observe(document);

  // Anything the theme editor injects later
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });

  /* ---- gentle media drift -------------------------------------------- */
  // A drift of 0 means off, and an element that is off is never given a
  // transform at all. The old code read the amount inside the loop as
  // `parseFloat(...) || 6`, and parseFloat('0') is 0, which is falsy, so
  // setting the slider to 0 in the customiser quietly restored the drift at 6%.
  // The scale exists only to give the translate somewhere to travel without
  // showing an edge, so with no travel there is no reason to scale either.
  var drifters = qsa('[data-drift]')
    .map(function (el) {
      // Transform the media INSIDE the frame, never the frame itself. Moving
      // the frame pushes it out of its own section and needs the section to
      // clip; moving the media within a frame that already clips is what
      // parallax actually is. The frame keeps its size and position.
      return {
        el: el,
        media: el.querySelector('img, video, svg'),
        amount: parseFloat(el.getAttribute('data-drift'))
      };
    })
    .filter(function (d) { return d.media && isFinite(d.amount) && d.amount > 0; });

  if (drifters.length) {
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var vh = window.innerHeight;
        drifters.forEach(function (d) {
          var rect = d.el.getBoundingClientRect();
          if (rect.bottom < -200 || rect.top > vh + 200) return;
          // Travel is measured against the FRAME, in pixels, not as a percentage
          // of the media. A percentage here resolves against the media's own
          // height, and the media is already 1 + 3*drift tall, so the travel grew
          // faster than the headroom and overshot it past about 17%. In pixels the
          // travel is exactly drift% of the frame and the CSS reserves 1.5 times
          // that on each side, so any drift value stays inside the frame.
          var progress = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - vh / 2) / vh));
          var px = progress * (d.amount / 100) * rect.height * -1;
          d.media.style.transform = 'translate3d(0,' + px.toFixed(2) + 'px,0)';
        });
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }
})();
